export const CONTACT_EMAIL = "support@pagepeers.com";

export const CONTACT_TOPICS = [
  "General question",
  "Account & login",
  "Reader circles",
  "Shelves & discovery",
  "Feedback & ideas",
  "Partnership",
  "Other",
];

export const HELP_FAQ = [
  {
    q: "How do I join the PagePeers community?",
    a: "Create a free account on PagePeers Club, build your shelf, and browse open reader circles. Most members are reading within their first ten minutes.",
  },
  {
    q: "I need help with my account",
    a: "Sign in at club.pagepeers.com and use account settings there. If you are locked out, mention your registered email in the form below and we will help.",
  },
  {
    q: "Can I suggest a shelf or circle feature?",
    a: "Yes — we read every message. Choose \"Feedback & ideas\" and tell us what would make your reading life calmer.",
  },
  {
    q: "How fast do you reply?",
    a: "We aim to respond within two business days. Circle and shelf questions often get pointers to guides while we follow up personally.",
  },
];

export const COMMUNITY_LINKS = [
  {
    title: "Reader circles",
    desc: "Find a small group already talking about books you love.",
    to: "/circles",
    cta: "Browse circles",
  },
  {
    title: "PagePeers Club",
    desc: "Account, shelf, and membership — the home for your library.",
    href: "https://club.pagepeers.com",
    cta: "Go to Club",
    external: true,
  },
  {
    title: "Reading guides",
    desc: "Practical essays on habits, circles, and discovery.",
    to: "/reading-guides",
    cta: "Read guides",
  },
];
